/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import { SelectV, BusinessAccounts, InputV2 , InputCurrency} from 'components';
import { useFormContext } from 'react-hook-form';
import { useStyles } from './Style';


const CalculationMethod = (props) => {
  const classes = useStyles();
  const methods = useFormContext();

  const { scPriceCalculationType } = methods.watch();

  return (
    <>
      <Grid item xs={6}>
        <BusinessAccounts
          errors={methods.formState.errors}
          control={methods.control}
          name="scGuildCode"
          label="حساب تفصیلی"
          tooltip="حساب تفصیلی کسب‌وکار محل واریز درآمد حاصل از فراخوانی این سرویس توسط مشتریان"
        />
      </Grid>
      <Grid item xs={6}>
        <InputV2
          label="مالیات بر ارزش افزوده"
          errors={methods.formState.errors}
          name="preferredTaxRate"
          register={methods.register}
          fullWidth
          control={methods.control}
          currency
          hasMargin={false}
          currencyText="%"
        />
      </Grid>
      <Grid item xs={6}>
        <SelectV
          label="روش محاسبه"
          name="scPriceCalculationType"
          options={[
            { value: 'FIXED', label: 'قیمت ثابت' },
            { value: 'ONRESPONSE', label: 'قیمت در هر فراخوانی' },
          ]}
          control={methods.control}
          rules={['required']}
          errors={methods.formState.errors}
          fullWidth
          defaultValue="FIXED"
        />
      </Grid>

      {scPriceCalculationType === 'FIXED' && (
        <Grid item xs={6}>
          <InputCurrency
            fullWidth
            label="قیمت"
            errors={methods.formState.errors}
            name="price"
            register={methods.register}
            rules={['required']}
            control={methods.control}
          />
        </Grid>
      )}

      {scPriceCalculationType === 'ONRESPONSE' && (
        <>
          <Grid item xs={3}>
            <InputV2
              fullWidth
              errors={methods.formState.errors}
              label="حداقل موجودی مصرف کننده"
              name="price"
              register={methods.register}
              rules={['required']}
              control={methods.control}
            />
          </Grid>

          <Grid item xs={3}>
            <InputCurrency
              fullWidth
              label="قیمت"
              errors={methods.formState.errors}
              name="scPriceHeader"
              register={methods.register}
              rules={['required']}
              control={methods.control}
            />
          </Grid>

          <Grid container item xs={6} alignItems="center">
            <Grid item xs={10}>
              <InputV2
                label="آدرس سرویس استعلام"
                fullWidth
                errors={methods.formState.errors}
                name="scPriceInquiryUrl"
                register={methods.register}
                rules={['required']}
                control={methods.control}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectV
                name="scInquiryHttpVerb"
                showLabel
                label=" "
                options={[
                  { value: 'GET', label: 'GET' },
                  { value: 'POST', label: 'POST' },
                ]}
                control={methods.control}
                rules={['required']}
                className={classes.select}
                errors={methods.formState.errors}
                defaultValue="GET"
                fullWidth
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default CalculationMethod;
